/**
 * FormSection — Titled card-like section wrapper for survey form groups.
 *
 * Props:
 *   title    string
 *   required boolean   — shows a red asterisk after the title
 *   children ReactNode
 */
export default function FormSection({ title, required, children }) {
  return (
    <section className="form-section card">
      {title && (
        <h3 className={`form-section-title${required ? ' required' : ''}`}>{title}</h3>
      )}
      {children}
    </section>
  )
}
